export interface ApiPostFeedbackRequest {
    comment: string;
    page_params?: string;
    type: string;
}

export type ApiPostFeedbackResponse = void;

export interface FeedbackApi {
    postFeedback: (data: ApiPostFeedbackRequest) => Promise<ApiPostFeedbackResponse>;
}

export const FeedbackApi = Symbol('FeedbackApi');
